/**
 * Auto-generated Zod schema for RepositoryVulnerabilityAlertReopenEvent
 * DO NOT MODIFY - regenerate with: bun run generate:schemas
 */

import type { RepositoryVulnerabilityAlertReopenEvent as RepositoryVulnerabilityAlertReopenEventOctokit } from '@octokit/webhooks-types';
import { z } from 'zod';

import {
  GitHubOrgSchema,
  OrganizationSchema,
  RepositorySchema,
  RepositoryVulnerabilityAlertAlertSchema,
} from './shared/index.js';

export const RepositoryVulnerabilityAlertReopenEventSchema = z.object({
  action: z.literal('reopen'),
  alert: RepositoryVulnerabilityAlertAlertSchema.and(
    z.object({
      state: z.literal('open'),
    }),
  ),
  repository: RepositorySchema,
  sender: GitHubOrgSchema,
  organization: OrganizationSchema.optional(),
}) satisfies z.ZodType<RepositoryVulnerabilityAlertReopenEventOctokit>;

export type RepositoryVulnerabilityAlertReopenEvent =
  RepositoryVulnerabilityAlertReopenEventOctokit;

export function isRepositoryVulnerabilityAlertReopenEvent(
  value: unknown,
): value is RepositoryVulnerabilityAlertReopenEvent {
  return RepositoryVulnerabilityAlertReopenEventSchema.safeParse(value).success;
}
